// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file upload/upload_responses.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file upload/upload_responses.proto.
 */
export const file_upload_upload_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch11cGxvYWQvdXBsb2FkX3Jlc3BvbnNlcy5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiZgoZR2VuZXJhdGVVcGxvYWRVcmxSZXNwb25zZRJBCgdzdWNjZXNzGAEgASgLMi4uY29tLmdlbS5iZmYuY29udHJhY3QuR2VuZXJhdGVVcGxvYWRVcmxTdWNjZXNzSABCBgoEdHlwZSLVAQoYR2VuZXJhdGVVcGxvYWRVcmxTdWNjZXNzEhEKCXVwbG9hZFVybBgBIAEoCRIWCg5wdWJsaWNGaWxlUGF0aBgCIAEoCRJYCg11cGxvYWRIZWFkZXJzGAMgAygLMkEuY29tLmdlbS5iZmYuY29udHJhY3QuR2VuZXJhdGVVcGxvYWRVcmxTdWNjZXNzLlVwbG9hZEhlYWRlcnNFbnRyeRo0ChJVcGxvYWRIZWFkZXJzRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASJmChlHZXRTdG9yYWdlU2Vzc2lvblJlc3BvbnNlEkEKB3N1Y2Nlc3MYASABKAsyLi5jb20uZ2VtLmJmZi5jb250cmFjdC5HZXRTdG9yYWdlU2Vzc2lvblN1Y2Nlc3NIAEIGCgR0eXBlImAKGEdldFN0b3JhZ2VTZXNzaW9uU3VjY2VzcxJECgtjcmVkZW50aWFscxgBIAEoCzIvLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlN0b3JhZ2VTZXNzaW9uQ3JlZGVudGlhbHMiqgEKGVN0b3JhZ2VTZXNzaW9uQ3JlZGVudGlhbHMSEwoLYWNjZXNzS2V5SWQYASABKAkSFwoPc2VjcmV0QWNjZXNzS2V5GAIgASgJEhQKDHNlc3Npb25Ub2tlbhgDIAEoCRISCgpleHBpcmF0aW9uGAQgASgJEhAKCGVuZHBvaW50GAUgASgJEg4KBnJlZ2lvbhgGIAEoCRITCgtzZXJ2aWNlTmFtZRgHIAEoCUIYChRjb20uZ2VtLmJmZi5jb250cmFjdFABYgZwcm90bzM'
  );

/**
 * @generated from message com.gem.bff.contract.GenerateUploadUrlResponse
 */
export type GenerateUploadUrlResponse =
  Message<'com.gem.bff.contract.GenerateUploadUrlResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GenerateUploadUrlResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GenerateUploadUrlSuccess success = 1;
           */
          value: GenerateUploadUrlSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GenerateUploadUrlResponse.
 * Use `create(GenerateUploadUrlResponseSchema)` to create a new message.
 */
export const GenerateUploadUrlResponseSchema: GenMessage<GenerateUploadUrlResponse> =
  /*@__PURE__*/
  messageDesc(file_upload_upload_responses, 0);

/**
 * @generated from message com.gem.bff.contract.GenerateUploadUrlSuccess
 */
export type GenerateUploadUrlSuccess = Message<'com.gem.bff.contract.GenerateUploadUrlSuccess'> & {
  /**
   * @generated from field: string uploadUrl = 1;
   */
  uploadUrl: string;

  /**
   * @generated from field: string publicFilePath = 2;
   */
  publicFilePath: string;

  /**
   * @generated from field: map<string, string> uploadHeaders = 3;
   */
  uploadHeaders: { [key: string]: string };
};

/**
 * Describes the message com.gem.bff.contract.GenerateUploadUrlSuccess.
 * Use `create(GenerateUploadUrlSuccessSchema)` to create a new message.
 */
export const GenerateUploadUrlSuccessSchema: GenMessage<GenerateUploadUrlSuccess> =
  /*@__PURE__*/
  messageDesc(file_upload_upload_responses, 1);

/**
 * @generated from message com.gem.bff.contract.GetStorageSessionResponse
 */
export type GetStorageSessionResponse =
  Message<'com.gem.bff.contract.GetStorageSessionResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetStorageSessionResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetStorageSessionSuccess success = 1;
           */
          value: GetStorageSessionSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetStorageSessionResponse.
 * Use `create(GetStorageSessionResponseSchema)` to create a new message.
 */
export const GetStorageSessionResponseSchema: GenMessage<GetStorageSessionResponse> =
  /*@__PURE__*/
  messageDesc(file_upload_upload_responses, 2);

/**
 * @generated from message com.gem.bff.contract.GetStorageSessionSuccess
 */
export type GetStorageSessionSuccess = Message<'com.gem.bff.contract.GetStorageSessionSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.StorageSessionCredentials credentials = 1;
   */
  credentials?: StorageSessionCredentials;
};

/**
 * Describes the message com.gem.bff.contract.GetStorageSessionSuccess.
 * Use `create(GetStorageSessionSuccessSchema)` to create a new message.
 */
export const GetStorageSessionSuccessSchema: GenMessage<GetStorageSessionSuccess> =
  /*@__PURE__*/
  messageDesc(file_upload_upload_responses, 3);

/**
 * @generated from message com.gem.bff.contract.StorageSessionCredentials
 */
export type StorageSessionCredentials =
  Message<'com.gem.bff.contract.StorageSessionCredentials'> & {
    /**
     * @generated from field: string accessKeyId = 1;
     */
    accessKeyId: string;

    /**
     * @generated from field: string secretAccessKey = 2;
     */
    secretAccessKey: string;

    /**
     * @generated from field: string sessionToken = 3;
     */
    sessionToken: string;

    /**
     * @generated from field: string expiration = 4;
     */
    expiration: string;

    /**
     * @generated from field: string endpoint = 5;
     */
    endpoint: string;

    /**
     * @generated from field: string region = 6;
     */
    region: string;

    /**
     * @generated from field: string serviceName = 7;
     */
    serviceName: string;
  };

/**
 * Describes the message com.gem.bff.contract.StorageSessionCredentials.
 * Use `create(StorageSessionCredentialsSchema)` to create a new message.
 */
export const StorageSessionCredentialsSchema: GenMessage<StorageSessionCredentials> =
  /*@__PURE__*/
  messageDesc(file_upload_upload_responses, 4);
